import { GlobalAlert, GlobalAlertsService } from '@adaptiva/core/alerts';
import { Destroyer, EnvService } from '@adaptiva/core/common';
import { WebStorageService } from '@adaptiva/core/storage';
import { compareVersion } from '@adaptiva/core/versioning';
import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class WhatsNewService extends Destroyer {

	public readonly alertKey: string = 'adaptiva.docs.whats_new';

	public readonly alertSuppressionKey: string = `${this.alertKey}.suppressed`;

	public readonly helpTagId: string = 'whats-new-tag';

	protected readonly env: EnvService = inject(EnvService);

	protected readonly alerts: GlobalAlertsService = inject(GlobalAlertsService);

	protected readonly storage: WebStorageService = inject(WebStorageService);

	protected readonly document: Document = inject(DOCUMENT);

	/**
	 * Checks the DOM for a `<link>` tag containing version info and a URL to the
	 * docs explaining what is new in the product at the specified version
	 */
	public showBanner(): void {
		// if anything is set for this key, assume suppressed
		const _lastSuppressedVersion: string = this.storage.getRecord<string>(this.alertSuppressionKey);
		const _helpTag: HTMLElement = this.document.getElementById(this.helpTagId);

		if (!_helpTag)
			return;

		const _docsUrl: string = _helpTag.getAttribute('href');
		const _helpVersion: string = _helpTag.dataset.version;

		// check if the user has already suppressed this version
		if (
			_lastSuppressedVersion != null &&
			compareVersion(_lastSuppressedVersion, _helpVersion) <= 0
		)
			return;

		this.alerts.set(
			new GlobalAlert({
				id: this.alertKey,
				notify: false,
				isDismissable: true,
				title: `See what's new in version ${this.env.build()}`,
				shouldSyncTabs: false,
				buttons: [{
					text: 'View Docs',
					look: 'solid',
					type: 'info',
					action: () => window.open(_docsUrl, '_blank'),
				}],
				onDismiss: () => {
					this.storage.setRecord<string>(this.alertSuppressionKey, _helpVersion);
				}
			})
		);
	}

}
